module.exports = __webpack_public_path__ + "static/media/glass-removebg-preview.79df9862.png";